import * as Period from '../../../../constants/Period';
var BADMINTON_PERIOD_MAP = {};
BADMINTON_PERIOD_MAP[3200] = Period.NOT_STARTED;
BADMINTON_PERIOD_MAP[3201] = Period.FIRST;
BADMINTON_PERIOD_MAP[3202] = Period.SECOND;
BADMINTON_PERIOD_MAP[3203] = Period.THIRD;
BADMINTON_PERIOD_MAP[3204] = Period.FINISHED;
export default BADMINTON_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/Badminton/PeriodMap.js